import { useContext } from 'react';
import { MarcuraPortCostContext } from './context';

export const useMarcuraPortCosts = () => {
  const context = useContext(MarcuraPortCostContext);

  if (!context) {
    throw new Error('usePortCosts must be used within MarcuraPortCostProvider');
  }

  return context;
};
